module.exports = __webpack_public_path__ + "static/media/Maax-Regular.8b0f15e4.woff2";